module.exports = __webpack_public_path__ + "static/media/logo.d44066d7.svg";